import { overlay_backgroundNotFocused, white100 } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { modal_transitionSpeed } from 'ext-ui/style/transitionSpeeds'
import { css } from 'styled-components'

export default css`
  .BaseModal-Content {
    /* Keep the box at its natural height and let the overlay scroll (see
       .BaseModal-Overlay below). margin:auto centers it within the flex
       overlay and collapses correctly so the top stays reachable when the
       modal is taller than the viewport. flex-shrink:0 stops the overlay's
       flex layout from squishing a tall box. position:relative anchors the
       absolutely-positioned .BaseModal-CloseButton. */
    position: relative;
    margin: auto;
    flex-shrink: 0;

    &:focus-visible {
      /* It is obvious that the modal has focus, b/c it is in the foreground */
      outline: none;
    }

    .BaseModal-CloseButton {
      position: absolute;
      top: ${spacing(-12)};
      right: ${spacing(-2)};

      &:hover {
        cursor: pointer;
      }
    }

    .BaseModal-Body {
      background-color: ${white100};
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
      border-radius: 10px;
    }

    /* VARIANTS */
    &.popup {
      width: 678px;

      .BaseModal-Body {
        padding: ${spacing(10)};
      }
    }

    &.interactive {
      width: 519px;
    }

    /* When the consumer renders its own surface (e.g. the legacy Popup card),
       strip the body chrome and the variant width so the child element defines
       the box. Declared after the variants so it wins by source order at equal
       specificity. */
    &.unstyled-body {
      width: auto;

      .BaseModal-Body {
        background-color: transparent;
        box-shadow: none;
        border-radius: 0;
        padding: 0;
      }
    }
  }

  /* Transition (both content and overlay fade) */
  .BaseModal-Overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;

    /* The overlay is both the backdrop and the scroll container, matching the
       legacy Redux modals (src/components/Popup/Popup.tsx): a tall modal
       scrolls the whole overlay rather than an inner div. align-items:center
       (not justify-content) centers horizontally while keeping the box's top
       reachable; the vertical padding gives breathing room so the close
       button — which sits above the box — never gets clipped on tall modals. */
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    padding: ${spacing(16)} 0;

    background-color: ${overlay_backgroundNotFocused};
    opacity: 0;
    transition: opacity ${modal_transitionSpeed} ease-in-out;

    &.BaseModal-Overlay-open {
      opacity: 1;
    }
    &.BaseModal-Overlay-closed {
      opacity: 0;
    }
  }
`
